import api from 'api/client';
import {
  CbtProgramStatus,
  TransformedProgram,
} from 'views/CbtBuilder/CbtBuilder.types';
import { toQueryStr } from 'helpers/queryUtils';
import { PaginatedRequest, STATUS } from './types';
import { DangerousAction } from './dangerousActions';
// import { cbt } from './mocks';

type CbtProgramMutationResponse = {
  id: string;
  status: string;
};
export const createCbtProgram = async (body: TransformedProgram) => {
  return api
    .post('cbt/create', { json: body })
    .json<CbtProgramMutationResponse>();
};

export const updateCbtProgram = async (
  programId: string,
  body: TransformedProgram
) => {
  return api
    .patch(`cbt/${programId}/update`, { json: body })
    .json<CbtProgramMutationResponse>();
};

export const deleteCbtProgram = async (programId: string) => {
  return api.delete(`cbt/${programId}/delete`).json<{ status: string }>();
};

type GetCbtProgramResponse = {
  data: {
    createdAt: string;
    createdBy: string;
    program: TransformedProgram;
    updatedAt: string;
  };
  status: string;
};
export const getGetCbtProgram = async (programId: string) => {
  return api.get(`cbt/${programId}`).json<GetCbtProgramResponse>();
};

type GetCbtProgramsRequest = PaginatedRequest & {
  page?: number;
  limit?: number;
};

export type CbtProgram = {
  program: TransformedProgram;
  dangerousAction?: DangerousAction;
  status?: CbtProgramStatus;
  createdBy: string;
  createdAt: string;
};

export type GetCbtProgramsResponse = {
  status: STATUS;
  total: number;
  // NOTE: for whatever reason CbtProgram response property for items is 'data' while other endpoints use 'items'
  data: CbtProgram[];
};

export const getCbtPrograms = async (
  query: GetCbtProgramsRequest = {}
): Promise<GetCbtProgramsResponse> => {
  // return new Promise((resolve) => {
  //   resolve(cbt as GetCbtProgramsResponse);
  // });
  return api.get(`cbt?${toQueryStr(query)}`).json();
};

export type CbtVideoProgram = {
  uid: string;
  title: string;
  imageUrl: string;
  lessons: {
    title: string;
    videoUrl: string;
    thumbnailUrl: string;
  }[];
};

export const getCbtVideos = async () => {
  const res = await api
    .get('cbt/videos')
    .json<{ status: string; cbtVideos: CbtVideoProgram[] }>();
  return res.cbtVideos;
};
